<div class="progress-wrapper">
  <div class="progress">
    <div
      class="progress-fill"
      [ngStyle]="{ width: percentage + '%'}"
    ></div>
  </div>
  <div class="progress-text">
    <span class="current">{{ value }}</span>
    <span> z {{ max }}</span>
  </div>
</div>
